import { render, staticRenderFns } from "./VariableProductTab.vue?vue&type=template&id=8dc7da16&scoped=true&"
import script from "./VariableProductTab.vue?vue&type=script&lang=js&"
export * from "./VariableProductTab.vue?vue&type=script&lang=js&"
import style0 from "./VariableProductTab.vue?vue&type=style&index=0&id=8dc7da16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc7da16",
  null
  
)

export default component.exports